export const hexToHexAlpha = (hex: string, alpha: number) =>
  `${hex}${Math.round(alpha * 255).toString(16)}`;
